<template>
  <div class="module-container">
    <div class="module-header">
      <div class="module-title" style="font-weight: bolder;">
        <span>运送管理</span>
      </div>
      <span class="more-link" @click="goToServiceMan">查看更多</span>
    </div>
    <div class="module-content">
      <div class="total-section">
        <div class="total-label"><img src="/static/image/six/yunshuguanli.png"
            style="width: 16px; height: 16px; margin-right: 8px; vertical-align: middle;">运送任务总数</div>
        <div class="total-value">{{ totalNumber }} <span class="unit">次</span></div>
      </div>
      <div class="chart-container">
        <div ref="chart" class="chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { tranClassStatistic } from '@/api/traConfig'
import { addDate, getCurTimeYMD } from '@/utils/index'

export default {
  name: 'TransportManagement',
  data() {
    return {
      chart: null,
      totalNumber: 0,
      transportData: [],
      loading: false,
      refreshInterval: null
    }
  },
  mounted() {
    this.fetchTransportData()
    window.addEventListener('resize', this.handleResize)
    // 设置定时刷新，每30分钟刷新一次
    this.refreshInterval = setInterval(this.fetchTransportData, 1800000)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chart) {
      this.chart.dispose()
    }
    // 清除定时器，避免内存泄漏
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async fetchTransportData() {
      this.loading = true
      // 先清空数据，确保即使数据不变也能触发重新渲染
      this.transportData = []
      this.totalNumber = 0
      try {
        const projectId = JSON.parse(window.localStorage.userInfo).projectId;
        const endDate = getCurTimeYMD();
        const startDate = addDate(endDate, -7);
        const { data } = await tranClassStatistic({
          projectId: projectId,
          startDate: startDate,
          endDate: endDate
        })
        if (data) {
          this.transportData = data.data
          // 计算总任务数
          this.totalNumber = data.data.reduce((sum, item) => sum + (item.count || 0), 0)
          // 初始化图表
          this.$nextTick(() => {
            this.initChart()
          })
        }
      } finally {
        this.loading = false
      }
    },
    initChart() {
      if (!this.$refs.chart) return

      this.chart = echarts.init(this.$refs.chart)

      // 准备图表数据
      const categories = this.transportData.map(item => item.type_name + '任务数量')
      const values = this.transportData.map(item => item.count || 0)

      // 准备柱子颜色
      const barColors = ['#64FAFF', '#00A2FC', '#B4FEDE', '#0BD189']

      const option = {
        grid: {
        left: '15%',
        right: '5%',
        top: '10%',
        bottom: '25%'
      },
        xAxis: {
          type: 'category',
          data: categories,
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            interval: 0,
            rotate: 25
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [
          {
            type: 'bar',
            data: values.map((value, index) => ({
              value,
              itemStyle: {
                color: barColors[index % barColors.length]
              }
            })),
            barWidth: '30%',
            itemStyle: {
              borderRadius: [4, 4, 0, 0],
              shadowBlur: 10,
              shadowColor: 'rgba(0, 186, 255, 0.5)'
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff',
              fontSize: 12,
              fontWeight: 'bold'
            }
          }
        ]
      }

      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    },
    goToServiceMan() {
      // 获取用户权限
      const userRoles = JSON.parse(decodeURI(window.localStorage.userRoles))
      // 计算日期参数（最近7天）
      const endDate = getCurTimeYMD()
      const startDate = addDate(endDate, -7)

      // 检查是否有调度中心权限
      if (userRoles && userRoles.includes('diaoduzhongxin')) {
        // 有权限，跳转到调度中心
        this.$router.push({
          path: '/transportMan/serviceMan',
          query: {
            startDate,
            endDate
          }
        });
      } else {
        // 无权限，提示
        this.$message({
          type: 'warning',
          message: '您暂无权限访问调度中心'
        });
      }
    }
  }
}</script>

<style scoped lang="scss">
.module-container {
  display: flex;
  flex-direction: column;
}

.module-header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 186, 255, 0.2);
}

.module-title {
  width: 435px;
  height: 35px;
  color: #fff;
  text-align: center;
  background: url("/static/image/equip/shebeiyunxingzhuangtai-bg.png") no-repeat center;

  span {
    margin-left: -186px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    font-size: 19px;
    color: #FFFFFF;
  }
}

.more-link {
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.more-link:hover {
  text-decoration: underline;
}

.module-content {
  padding: 10px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.total-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 186, 255, 0.07);
  border: 1px solid #5b99d6;
  padding: 10px;
}

.total-label {
  font-size: 14px;
  color: #fff;
}

.total-value {
  font-size: 24px;
  font-weight: bold;
  color: #03F5FF;
}

.total-value .unit {
  font-size: 16px;
  font-weight: normal;
  margin-left: 3px;
  color: #fff;
}

.chart-container {
  padding: 15px;
  flex: 1;
}

.chart {
  width: 100%;
  height: 100%;
  min-height: 200px;
}
</style>
